import { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import GTManager from '@widgets/gtm';
import SentryManager from '@widgets/sentry-manager';
import { authActions } from '@actions';
import { authService } from '@services';
import { RoutePath } from '@constants/routes';

const VerifyEmail = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const history = useHistory();

    const verifyEmail = async () => {
        try {
            const user = await authService.verifyEmail(params.token);
            GTManager.update(user);
            SentryManager.setUser(user);
            dispatch(authActions.setUser(user));
            history.push(RoutePath.Home);
        } catch (_) {
            history.push(RoutePath.Login);
        }
    };

    useEffect(() => {
        verifyEmail();
    }, []);

    return <div />;
};

export default VerifyEmail;
